/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'schedule': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M172.8 435.2h153.6v153.6H172.8V435.2zm262.4 0h153.6v153.6H435.2V435.2zm256 0h153.6v153.6H691.2V435.2zm-512 243.2h153.6V832H179.2V678.4zm256 0h153.6V832H435.2V678.4zm256 0h153.6V832H691.2V678.4z"/><path pid="1" d="M953.6 121.6H832v-96c0-12.8-6.4-19.2-19.2-19.2h-89.6c-12.8 0-19.2 6.4-19.2 19.2v96H320v-96c0-12.8-6.4-19.2-19.2-19.2h-89.6c-6.4 0-19.2 6.4-19.2 19.2v96H70.4C32 121.6 0 153.6 0 192v755.2c0 38.4 32 70.4 70.4 70.4h876.8c38.4 0 70.4-32 70.4-70.4V192c6.4-38.4-25.6-70.4-64-70.4zm-19.2 800c0 6.4-6.4 12.8-12.8 12.8H96c-6.4 0-12.8-6.4-12.8-12.8V339.2c0-6.4 6.4-12.8 12.8-12.8h825.6c6.4 0 12.8 6.4 12.8 12.8v582.4z"/>'
  }
})
